<template lang="pug">
.container-select
  svg(version="1.1", xmlns="https://www.w3.org/2000/svg", xmlns:xlink="https://www.w3.org/1999/xlink", x="0px", y="0px", style="display: none;")
    symbol#wave
      path(d="M420,20c21.5-0.4,38.8-2.5,51.1-4.5c13.4-2.2,26.5-5.2,27.3-5.4C514,6.5,518,4.7,528.5,2.7c7.1-1.3,17.9-2.8,31.5-2.7c0,0,0,0,0,0v20H420z")
      path(d="M420,20c-21.5-0.4-38.8-2.5-51.1-4.5c-13.4-2.2-26.5-5.2-27.3-5.4C326,6.5,322,4.7,311.5,2.7C304.3,1.4,293.6-0.1,280,0c0,0,0,0,0,0v20H420z")
      path(d="M140,20c21.5-0.4,38.8-2.5,51.1-4.5c13.4-2.2,26.5-5.2,27.3-5.4C234,6.5,238,4.7,248.5,2.7c7.1-1.3,17.9-2.8,31.5-2.7c0,0,0,0,0,0v20H140z")
      path(d="M140,20c-21.5-0.4-38.8-2.5-51.1-4.5c-13.4-2.2-26.5-5.2-27.3-5.4C46,6.5,42,4.7,31.5,2.7C24.3,1.4,13.6-0.1,0,0c0,0,0,0,0,0l0,20H140z")
  Details-Winner(v-if="$root.show_details", root-variable="show_details", :winner-val="getWinnerJson", :concurso-val="getConcursoJson")
  .base-alert(v-if="show_alert")
    .overflow-alert(@click="show_alert = false")
    .alert-content
      .title-players-red ¿Está seguro que desea volver a seleccionar aleatoriamente un ganador?
      button.button(@click='confirmOption') SI
      button.button.cancel(@click='show_alert = false') NO
  .square(v-show="!$root.show_details || show_alert")
    .box-win(:style="'background-image: url(/images/beach/Surfboard'+idTable+'-90.svg)'")
      .info-text(v-if="first_time") {{ count }}
        span(:class="{ 'active' : loaded_count }") ¡PARTICIPANTES PARA ESTE MES!
      .info-text(v-if="show_winner",@click='$parent.showTickets(false)') {{ $root.winner.nombre }}
      //.roulette(ref="roulette")
        .template(v-for="(participant, index) in dataConcurse", @click="showDetailsWinner(participant.id)", :class="{ 'winner' : participant.id == $root.winner.id }" :id="'participant-id-' + participant.id", :key="index")
          span.matricula {{ participant.matricula }}
          span.name {{ participant.nombre }}
    //.arrow(ref="arrow", :class="{ 'active' : loaded_count &&  !first_time }")
    .divide-buttons
      button.button(@click='start', v-if="loaded_count", :class="{ 'is-loading' : $root.sending, 'select-other-winner' : winnerData || $root.winner.id != null, 'select-winner' : !winnerData || $root.winner.id == null }", :disabled="!loaded_count || $root.sending")
      button.button.view-winner(@click='$parent.showTickets(false)', v-if="loaded_count && $root.winner.id!=null")
</template>

<script>

import DetailsWinner from './DetailsWinner'

export default {
  props: {
    code: Object,
    dataConcurse: Array,
    winnerData: Object,
    idTable: Number
  },
  data() {
    return {
      offset: 0,
      first_time: true,
      first_show: true,
      show_winner: false,
      count: 0,
      loaded_count: false,

      show_alert: false,
      confirm: false
    }
  },
  components: {
    DetailsWinner
  },
  computed: {
    getWinnerJson(){
      return JSON.stringify(this.$root.winner)
    },
    getConcursoJson(){
      return JSON.stringify(this.code)
    }
  },
  methods: {
    confirmOption() {
      let vm = this
      vm.show_alert = false
      vm.confirm = true
      vm.start()
    },
    showDetailsWinner(id) {
      let vm = this
      if (id == vm.$root.winner.id) {
        vm.$root.show_details = true
      }
    },
    countParticipants() {
      let vm = this
      let c = setInterval(function() {
        vm.count += Math.floor(Math.random() * 30) + 10
        if ((vm.count > vm.dataConcurse.length) || (vm.count < 0)) {
          vm.count = vm.dataConcurse.length
          clearInterval(c)
          vm.loaded_count = true
        }
      }, 20)
    },
    start() {
      let vm = this
      if ((!vm.confirm && vm.winnerData != null ) || (!vm.confirm && vm.$root.winner.id != null )) {
        vm.show_alert = true
      } else {
        vm.$parent.selectingWinner = !vm.$parent.selectingWinner
        vm.$root.sending = !vm.$root.sending
        vm.first_time = false
        vm.first_show = false
        vm.show_winner = false

        axios.get(`/api/concursos/${vm.code.code}/setRandomWinner`)
        .then(function (response) {
          vm.$root.winner = response.data.data
          vm.confirm = false
          vm.offset = 0
          vm.show_winner = true
        })
        .catch(function (error) {
          console.log(error)
        })
        .then(() => {
          vm.$root.sending = !vm.$root.sending
          vm.$parent.selectingWinner = !vm.$parent.selectingWinner
        })
      }
    },
  },
  mounted() {
    this.countParticipants()
    if(this.winnerData != null){
      this.$root.winner = this.winnerData
    }else{
      this.first_show = false
    }
  }
}
</script>

<style lang="sass" scoped>
  .container-select
    position: fixed
    z-index: 100
    width: 100%
    height: 100%
    top: 0
    left: 0
  .button[disabled], fieldset[disabled] .button
    background: transparent
    opacity: 1
    border-color: none
    box-shadow: none
  .overflow-alert
    position: fixed
    width: 100%
    height: 100%
    top: 0
    left: 0
    background: rgba(0, 0, 0, 0.47)
    z-index: 3
    cursor: pointer
  .alert-content
    position: fixed
    width: 850px
    text-align: center
    top: 50%
    left: 50%
    padding: 50px 80px 0px 235px
    background-position: center
    background-repeat: no-repeat
    background-image: url('/images/beach/small_ticket.svg')
    transform: translate(-50%, -50%)
    z-index: 4
    border-radius: 50px
    font-size: 25px
    overflow: hidden
    filter: drop-shadow(0px 0px 10px rgba(0,0,0,.4))
    .button
      margin-top: 50px!important
      width: 100px!important
      height: 50px!important
  .winner
    background: rgba(255, 235, 59, 1)
    //animation: fade .4s ease infinite alternate
    cursor: pointer
    position: relative
    transition: all .3s ease
    &:hover
      background: #fcbf00
    &:after
      content: ''
      position: absolute
      width: 0
      height: 0
      border-left: 20px solid transparent
      border-right: 20px solid transparent
      border-top: 30px solid #a289cf
      top: 0
  .container
    z-index: 10
  .info-text
    text-shadow: 1px 2px 7px rgb(0, 0, 0)
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    font-size: 30px
    line-height: 28px
    text-align: center
    font-weight: bold
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    transition: all .3s ease
    & .loading-text
      font-size: 17px
      text-align: center
    &.no-show
      opacity: 0
    & span
      font-size: 20px
      text-align: center
      transition: all .3s ease
      height: 0px
      overflow: hidden
      &.active
        height: 90px
  .square
    position: absolute
    top: 45%
    left: 50%
    transform: translate(-50%, -50%)
    width: 500px
    margin: 60px auto
    margin-top: 0
    display: flex
    flex-direction: column
    align-items: center
    //transform: skewY(-5deg)
    animation: fade .3s ease
  .box-win
    width: 600px
    height: 200px
    //background: url(/images/beach/Surfboard4-90.svg)
    overflow: hidden
    background-position: center
    background-size: contain
    background-repeat: no-repeat
    z-index: 1
    position: relative
    color: #fff
  .roulette
    width: 400px
    height: 200px
    display: inline-flex
    opacity: 0
    transition: all .3s ease
    & div
      min-width: 200px
      height: 183px
      display: inline-flex
      flex-direction: column
      align-items: center
      justify-content: center
      border-right: 2px solid rgba(162, 137, 207, 0.4)
      padding: 0 10px
      & i
        font-size: 72px
      & span
        font-size: 32px
        text-align: center
        &.name
          font-size: 15px
          display: -webkit-box
          -webkit-font-smoothing: antialiased
          -webkit-line-clamp: 2
          -webkit-box-orient: vertical
          overflow: hidden
  .arrow
    width: 0
    height: 0
    border-left: 25px solid transparent
    border-right: 25px solid transparent
    border-bottom: 100px solid #a289cf
    position: relative
    top: -85px
    opacity: 0
    transition: all .4s ease
    &.active
      opacity: 1
  button
    background: transparent
    border: 0
    padding: 0 30px
    font-weight: bold
    font-size: 20px
    color: #4f4f4f
    border-radius: 5px
    outline: none
    cursor: pointer
    -webkit-transition: all .4s ease
    transition: all .4s ease
    -webkit-animation: fade .3s ease
    animation: fade .3s ease
    width: 300px
    background-size: contain
    background-repeat: no-repeat
    height: 190px
    transform: translateY(-85px)
    z-index: 0
    &:hover
      transform: translateY(-73px)
    &.select-other-winner
      background-image: url(/images/concurse/select_again.png)
    &.select-winner
      background-image: url(/images/concurse/select.png)
    &.view-winner
      background-image: url(/images/concurse/view_winner.png)
    &.cancel
      margin-left: 20px
  .shine
    animation: brillo .5s ease
    animation-iteration-count: 2

  .txt
    margin-top: 1em
    font-family: Montserrat
    color: #FFF
  .title-players-red
    margin-top: 10px
    letter-spacing: 3px
    font-family: "Montserrat-Black"
    background: linear-gradient(to bottom, #e98523 , #ee3078)
    -webkit-background-clip: text
    -webkit-text-fill-color: transparent
    text-align: center
    margin-bottom: 0
    font-size: 2rem
    font-weight: bold
    margin-bottom: 75px
</style>



// WEBPACK FOOTER //
// resources/js/components/Winners2020/SelectWinner.vue